import React from 'react';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { MaskedTextBox, MaskedTextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { GearFieldWrapper } from '../GearFieldWrapper';

interface MaskedInputFieldProps extends FieldRenderProps {
  mask: string;
}

export const FormMaskedInput: React.FC<MaskedInputFieldProps> = fieldRenderProps => {
  const { mask, onChange, disabled, ...restProps } = fieldRenderProps;

  const handleChange = (event: MaskedTextBoxChangeEvent) => {
    if (onChange) {
      onChange({
        value: event.target.rawValue
      });
    }
  };

  return (
    <GearFieldWrapper {...restProps} onChange={onChange}>
      <MaskedTextBox
        name={restProps.name}
        valid={restProps.valid}
        value={restProps.value}
        defaultValue={restProps.defaultValue}
        onChange={handleChange}
        mask={mask}
        validationMessage={restProps.validationMessage || undefined}
        disabled={disabled}
      />
    </GearFieldWrapper>
  );
};
